import { request } from '@/utils/request';
import type { ApiResponse, WrappedItemsResult, WrappedResult } from './types';

const boardingsApi = {
  getAll(params?: cyrian.api.boardings.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.boardings.Boarding[]>> {
    return request({
      method: 'get',
      url: '/boardings',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.boardings.Boarding>> {
    return request({
      method: 'get',
      url: `/boardings/${id}`,
    });
  },
  create(data: cyrian.api.boardings.Params): ApiResponse<WrappedResult<cyrian.api.boardings.Boarding>> {
    return request({
      method: 'post',
      url: '/boardings',
      data,
    });
  },
  update(id: number, data: cyrian.api.boardings.Params): ApiResponse<WrappedResult<cyrian.api.boardings.Boarding>> {
    return request({
      method: 'patch',
      url: `/boardings/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/boardings/${id}`,
    });
  },
  getAvailableLots(id: number): ApiResponse<WrappedItemsResult<cyrian.api.boardings.Lot[]>> {
    return request({
      method: 'get',
      url: `/boardings/${id}/available-lots`,
    });
  },
  addLots(id: number, data: cyrian.api.boardings.LotsParam): ApiResponse<WrappedResult<cyrian.api.boardings.Boarding>> {
    return request({
      method: 'post',
      url: `/boardings/${id}/add-lots`,
      data,
    });
  },
  removeLots(
    id: number,
    data: cyrian.api.boardings.LotsParam,
  ): ApiResponse<WrappedResult<cyrian.api.boardings.Boarding>> {
    return request({
      method: 'post',
      url: `/boardings/${id}/remove-lots`,
      data,
    });
  },
  report(id: number) {
    return request({
      method: 'get',
      url: `/boardings/${id}/report`,
      config: {
        responseType: 'blob',
      },
    });
  },
};

export default boardingsApi;
